// eslint-disable-next-line no-shadow
export enum CompanyResultViewTypes {
  BestMatchFound = 1,
  NoMatchFound = 2,
  SoleProprietorship = 3,
  NoScore = 4,
  LowScore = 5,
  IndustrySourceNotQualified = 6,
  NotQualified = 7,
  PreQualified = 8,
  WrongCustomers = 9,
  WrongLendingPractices = 10,
  WrongInvoicingPractices = 11,
  WrongBusinessIndustry = 12,
}
